// src/utils/lessons/fetchLessonCount.js

export async function fetchLessonCountAndLimit(supabase) {
  if (!supabase) {
  return null;
  }

  try {
    // --- Get the authenticated user ---
    const { data: { user } = {} } = await supabase.auth.getUser();
    if (!user) {
  return null;
    }

    // --- Fetch count of saved lessons ---
    const { count, error: countErr } = await supabase
      .from("saved_lessons")
      .select("*", { count: "exact", head: true })
      .eq("user_id", user.id);

    if (countErr) {
      console.warn("fetchLessonCount error:", countErr.message);
  return null;
    }

    // --- Fetch plan from profile ---
    const { data: profile, error: profileErr } = await supabase
      .from("profiles")
      .select("plan")
      .eq("id", user.id)
      .single();

    const planName = profile?.plan || "Guest";

    // --- Apply lesson limit rules ---
    const PLAN_LESSON_LIMITS = {
      guest: 15,
      basic: 50,
      pro: 100,
      premium: Infinity,
    };

    const limit =
      PLAN_LESSON_LIMITS[planName.toLowerCase()] ??
      PLAN_LESSON_LIMITS["guest"];

    return {
      count: count || 0,
      limit,
    };
  } catch (err) {
    console.error("fetchLessonCountAndLimit failed:", err);
    return null;
  }
}
